export function isMobile() {
  // 这里定义 576px 作为手机/电脑的临界值
  return document.documentElement.clientWidth <= 576
}
